module.exports = __webpack_public_path__ + "img/symbol_0.2b75684d.png";